/**
 * ---------------------------------------------------
 * AUTENTICAÇÃO
 * ---------------------------------------------------
 */
export const SIGN_IN_REQUEST = '@auth/SIGN_IN_REQUEST';
export const SIGN_IN_SUCCESS = '@auth/SIGN_IN_SUCCESS';
export const SIGN_IN_FAILURE = '@auth/SIGN_IN_FAILURE';
export const SIGN_OUT = '@auth/SIGN_OUT';

/**
 * ---------------------------------------------------
 * REVOKE TOKEN
 * ---------------------------------------------------
 */
export const REVOKE_TOKEN_REQUEST = '@auth/REVOKE_TOKEN_REQUEST';
export const REVOKE_TOKEN_SUCCESS = '@auth/REVOKE_TOKEN_SUCCESS';
export const REVOKE_TOKEN_FAILURE = '@auth/REVOKE_TOKEN_FAILURE';

/**
 * ---------------------------------------------------
 * UPDATE PROFILE HOSPITAL
 * ---------------------------------------------------
 */
export const UPDATE_PROFILE_HOSP_REQUEST = '@auth/UPDATE_PROFILE_HOSP_REQUEST ';
